// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SDC72h","spinner__inner":"_7B7GZ+","lds-ring":"_5kJi2I"};